// extracted by mini-css-extract-plugin
export default {"page_wrapper":"unsubscribe_page_wrapper__AvJ+6","btn":"unsubscribe_btn__+Xr3I"};